export default {
    zh:{
        title:'试算',
    },
    en:{
        title:'calculate',
    }
}
